
export class InitProcessusSupplier {
  title: string;
  requiredSteps: string[];
  actionStartWorkflowLabel: string;
}
